module.exports = __webpack_public_path__ + "static/media/18ECA5.87a2166a.jpg";